import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AddInvestor from "./AddInvestor";
import * as Constants from "../partials/CommonConstant"

const AddEditInvestor = (props) => {
  const navigate = useNavigate();
  let location = useLocation();
  let isEdit = false;
  let splitPath = location.pathname.split("/")
  let investorId = "";
  if (splitPath.length > 2) {
    investorId = splitPath[2];
    isEdit = true;
  }

  const callBackSuccess = (data) => {
    navigate(Constants.investors);
  }

  return (
    <div className="dashboard-card-wrapper">
      <div className="row">
        <AddInvestor callBackSuccess={(data) => callBackSuccess(data)}
          isEdit={isEdit}
          investorId={investorId}
        />
      </div>
    </div>
  )
}
export default AddEditInvestor;